import { getWidgetId, replaceErrors } from '../utils/common'
import ajaxRequest from './ajaxRequest';
export const http = {
    // 封装ajax请求
    request (options) {
        if (options.fetchType === 'ajaxRequest') {
            return this.httpGetRequest(options)
        }
        let requestParams = {
            url: options.url,
            method: options.type || 'get',
            qs: options.data,
            timeout: 15000,
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            crossDomain: true
        };
        if (requestParams.method.toLocaleLowerCase() === 'post') {
            requestParams.body = options.data;
            delete requestParams.qs;
        }
        const promise =  new Promise((resolve, reject) => {
            window.aladdin.http.request(requestParams, function (err, res) {
                // 错误处理
                if (err) {
                    reject(err);
                    return;
                }
                if (res?.status === 200) {
                    resolve(res);
                } else {
                    reject(res);
                }
            });
        });
        return promise;
    },
    httpGetRequest (options) {
        let requestParams = {
            url: options.url,
            timeout: 15000,
        };
        const promise =  new Promise((resolve, reject) => {
            ajaxRequest(requestParams, function (err, res) {
                // 错误处理
                if (err) {
                    reject(err);
                    return;
                }
                if (res?.status === 200) {
                    resolve(res);
                } else {
                    reject(res);
                }
            });
        });
        return promise;
    }
};